
import { ActivatedRoute, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CancelPatVisit } from '../../outpatient/patient-visit/cancel-patient-visit/cancel-patient-visit.component';
import { ContractListComponent } from '../contracts/index';
import { FamilyDetailComponent } from '../family-details';
import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { PatStopDealComponent } from '../patient-stopdeal';
import { PatientService } from './patient.service';
import { PatientVM } from './patient';
import { UserSessionService } from '../../shared';
import { VisitsHistoryComponent } from '../../outpatient/out-pat-appointment/out-pat-reservation/visits-history/visits-history.component';
import { MedicalDataPopupComponent } from '../../medical-recored/emr-doctors/medical-data-popup/medical-data-popup.component';
import { ModalContainerComponent } from '../../blocks/ui-component/modal-container/modal-container.component';
import { CallPatientRepoService } from '../../outpatient/portal-scheduling-management/scheduling-manage-tabs/call-patient-repo.service';
import { ToastService } from '../../blocks';
import { ServiceHistoryComponent } from '../../orders/service-history';
import { FutureReservationPrintComponent } from '../../outpatient/future-reservation-print/future-reservation-print.component';
import { NicuVaccineScheduleComponent } from '../new-born/nicu-vaccine-schedule/nicu-vaccine-schedule.component';
import { RegpatHistoryOnOldSystemComponent } from '../old-system-history';
import { ToastrService } from 'ngx-toastr';

//services
@Component({
  selector: 'sanabel-patients',
  templateUrl: './patient-list.component.html',
  styleUrls: ['./patient-list.component.css']
})
export class PatientListComponent implements OnInit, OnDestroy {

  @Input()
  public parent: string;
  @Output() private emitAddPatient: EventEmitter<number> = new EventEmitter<number>();
  @Output() private emitSelectedPatient: EventEmitter<PatientVM> = new EventEmitter<PatientVM>();
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  visitType: any;
  @Input() allowAddPat: boolean;
  @Input() RadStep: boolean;

  @Input() public mother: number;
  @Input() patFromCallCenter: number;
  @Input()
  set showHistory(value: boolean) {
    if (value) {
      this.isHistory = true;
    }
  }
  @Input()
  set fixedVisitType(value) {
    if (value) {
      this.visitType = value;
      if (this.visitType == 1) {
        this.isHistory = true;
      }
    }
  }
  @Input() public fixedVisitStatus: number;
  @Input() public fixedBillNotExtracted: number;
  @Input() parentUIKey: string;
  patient: PatientVM;
  patientSearchObj: PatientVM = <PatientVM>{};
  patientSearchObjData: PatientVM = <PatientVM>{};
  isHistory = false;
  visits: any[];
  wordArray = [];
  toggleFillter: boolean = true;
  dynamicComponent: any;
  actionRowData: any;

  totalRecords: number = 0;
  patients: PatientVM[];
  PatientParms;
  patientTransfereFlag: number = 0;
  @ViewChild(VisitsHistoryComponent) visitsHistoryComponent: VisitsHistoryComponent;

  @ViewChild('contractListComponent') contractListComponent: ContractListComponent;
  @ViewChild(CancelPatVisit) cancelPatVisit: CancelPatVisit;
  @ViewChild('popup') content: ModalContainerComponent;
  @ViewChild('popup2') content2: ModalContainerComponent;
  constructor(
    public _callRepo: CallPatientRepoService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private _patientService: PatientService,
    private _router: Router,
    private _toastService: ToastService,

    private _userSessionService: UserSessionService,
    private _route: ActivatedRoute) { }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  patStopDeal(patient) {
    this._userSessionService.setSessionKey('patientParms', patient.code);
    this.dynamicComponent = PatStopDealComponent;
    this.content.openModal("PatStopDealComponent", "PatientListComponent", patient.code);
  }

  onPatVisitCancel(visit) {
    this._router.navigate(['CancelPatVisit'], { relativeTo: this._route });
    this.cancelPatVisit._getPatVisit(visit.serial);
  }

  onSearchClick(_searchOnj: any) {
    this.patientSearchObj = _searchOnj;
    if (isNaN(+this.patientSearchObj.code) || !isFinite(+this.patientSearchObj.code)) {
      // this._toastService.activateMsg(this.translate.currentLang == 'ar'?'من فضلك ادخل الرقم القومي':'Please enter MRN')
      // return '';

      this.patientSearchObj.code = null;
      this.patientSearchObj.customCode = _searchOnj.code
    }
    this.patientSearchObj.ngbToDate = _searchOnj.ngbToDate;
    this.patientSearchObj.ngbFromDate = _searchOnj.ngbFromDate;
    this.patientSearchObj.fnameEn = _searchOnj.fnameEn;
    this.patientSearchObj.snameEn = _searchOnj.snameEn;
    this.patientSearchObj.tnameEn = _searchOnj.tnameEn;
    this.patientSearchObj.offset = 0;
    this.patientSearchObj.pageSize = 20;
    this.searchPatients(this.patientSearchObj, false);
    let patParams: any = {}
    patParams.patCode = -1;
    patParams.classList = -1;
    this._userSessionService.setSessionKey("MediacalDataForPatient", patParams);
  }
  getCssClasses = (mergedFlag: boolean) => {
    if (mergedFlag == true) {
      return 'deleted-row';
    }
    else {
      return ''
    }
  }
  selectTransferPatient(patient) {
    this._patientService.searchPatients(patient).subscribe(
      searchResult => {
        this.patients = searchResult ? searchResult.data : [];
        this.patients.forEach(el => {
          if (el.mergedFlag == 1) {
            el.code = el.mergedByPatCode
          }
        });
      })

  }
  searchPatients(patientSearchObj: PatientVM, paginate: boolean) {
    this.patients = [];
    if (this.visitType > 0) {
      patientSearchObj.visitType = this.visitType;
    }
    if (this.fixedVisitStatus > 0) {
      patientSearchObj.visitStatus = this.fixedVisitStatus;
    }

    if (this.fixedBillNotExtracted > 0)
      patientSearchObj.billNotExtracted = this.fixedBillNotExtracted;

    if ((this.mother != undefined || this.mother != null)) {
      patientSearchObj.gender = 2;
    }

    if (this.visitType == 1) {
      this._patientService.searchInPatients(patientSearchObj)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          searchResult => {
            if (paginate) {
              this.patients = this.patients.concat(searchResult.data);
            } else {
              this.patients = searchResult.data;
            }
            if (this.patientTransfereFlag == 1) {
              this.selectedPatient(this.patients[0])
            }
            this.patients.forEach(el => {
              if (el.mergedFlag == 1) {
                el.code = el.mergedByPatCode
              }
            });
            this.updatePaginator();
            this.visitsHistoryComponent.reset();

          }, error => console.error(error),
          () => null);

    } else {
      this._patientService.searchPatients(patientSearchObj)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          searchResult => {
            if (paginate) {
              this.patients = this.patients.concat(searchResult.data);
            } else {
              this.patients = searchResult.data;
            }
            if (this.patientTransfereFlag == 1 && this.patients[0].code > 0) {
              this.selectedPatient(this.patients[0])
            }
            this.patients.forEach(el => {
              if (el.mergedFlag == 1) {
                el.code = el.mergedByPatCode
              }
              // el.fullAddressAr = el.fullAddressAr && el.fullAddressAr.length > 0 ? el.fullAddressAr : el.addressAr;
              // el.fullAddressEn = el.fullAddressEn && el.fullAddressEn.length > 0 ? el.fullAddressEn : el.addressEn;
            });

            //namingTranslationSettings///

            /* if (this.patients['namingTranslationSettings'].value==1) {
                 console.log(this.patients['namingTranslationSettings'].value)
                 this.patients = this.patients.concat(searchResult.data);
             } else
                 this.patients = searchResult.data;*/

            this.updatePaginator();
            this.visitsHistoryComponent.reset();

          }, error => console.error(error),
          () => null);
    }

  }

  togglefillter() {
    this.toggleFillter = !this.toggleFillter;
  }

  /**
 * on page click used for navigation
 * @param _parms - The object  containing the --first-- row number   and  ---rows---  count .
 */
  paginate(_parms: any) {
    this.patientSearchObj.offset = _parms.first;
    this.patientSearchObj.pageSize = _parms.rows;
    this.searchPatients(this.patientSearchObj, true);
  }
  /**
 * to update  totalRecords @input used to calc paging in datatable
 */
  updatePaginator() {
    this.totalRecords = (this.patients ? (this.patients.length > 0 ? this.patients[0].rowsCount : 0) : 0);
  }

  ngOnInit() {

    this._userSessionService.subscribeToKey$('RouterParms').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.patients = [];
          // this.isHistory = false;// master reda for m.abdo
        }
      });

    this._userSessionService.subscribeToKey$('patientTransfer').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {

        this.startSearchForPat('patientTransfer', keys);
        // console.log(keys)

      });
    this._userSessionService.subscribeToKey$('CallConfirmationAndReservation').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {

        if (keys.value) {
          if (keys.value['callerCode'] && keys.value['patCode'] == null) {
            this.patientSearchObj = keys.value
            this.goToAddPatient(true);
          } else {
            let obj: any = {};
            obj.offset = 0;
            obj.pageSize = 20;
            obj.code = keys.value.patCode;
            if (!obj.code)
              obj.fastSearchData = keys.value.patCode;
            this.patientTransfereFlag = 1
            this.searchPatients(obj, true)
          }
        }

      });
  }
  startSearchForPat(key: string, keys: any) {
    if (keys && keys.value) {
      if (!keys.value.docId)
        keys.value.docId = this._callRepo.DocId;
      this._userSessionService.setSessionKey('patientParms', keys.value);
      this.patientTransfereFlag = 1
      let obj: any = {};
      obj.offset = 0;
      obj.pageSize = 20;
      obj.code = keys.value.patCode;
      if (!obj.code)
        obj.fastSearchData = keys.value.patCode;


      this.searchPatients(obj, true)

    }

  }
  selectedPatient(patient) {
    if (patient.mergedFlag == 1) {
      patient.patientCode = patient.mergedByPatCode
    } else {
      patient.patientCode = patient.patientCode
    }
    this._userSessionService.setSessionKey('patientParms', patient);
    this.emitSelectedPatient.emit(patient);
  }

  selectVisit(visit: any) {
    this.patient['visitSerial'] = visit['visitSerial'];
    this.patient['lastVisitSerial'] = visit['visitSerial'];
    this.patient['lastVisitType'] = visit['visitType'];
    this.patient['lastVisitEndDate'] = visit['visitEndDate'];
    this.patient['docId'] = visit['docId'];
    this.patient['docNameAr'] = visit['docNameAr'];
    this.patient['docNameEn'] = visit['docNameEn'];
    this.patient['contractId'] = visit['contractId'];
    this._userSessionService.setSessionKey('patientParms', this.patient);
    this.emitSelectedPatient.emit(this.patient);
  }

  selectedHistory(patient) {
    this.patient = patient;
    this.visitsHistoryComponent.getPatientVisits(patient.code, patient.visitsType);
    this.isHistory = true;
    this.visitsHistoryComponent.toggle2(true);
  }

  hideVisitHistory(event) {
    this.isHistory = false;
  }

  goToAddPatient(CallReservation: boolean) {
    if (this.parent == 'OutPatReservation' && this.patientSearchObj && Object.keys(this.patientSearchObj).length !== 0) {
      //AMER add this.patientSearchObj && Object.keys(this.patientSearchObj).length !== 0 26/02/2022
      let _patientForEdit = Object.assign({}, this.patientSearchObj);
      _patientForEdit["AddNew"] = true;
      this._userSessionService.removeSessionKey('patientForEdit');
      if (CallReservation) {
        this._userSessionService['AddNewPatientFromCallCenter'] = true
        this._userSessionService.setSessionKey('reservationCallRegister', _patientForEdit);
      }
      else {
        this._userSessionService['AddNewPatientFromCallCenter'] = false

      }
      this.emitAddPatient.emit(32);
    } else {
      this.emitAddPatient.emit(32);
    }
  }
  //---------------------------------------------
  duplicatSessionOrStop(patCode) {
    this._patientService.UpdatedduplicatSessionOrStop(patCode)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        s => {
          if (s.msgData[0]['msgID'] == 5) {

          }
        },
        error => console.log(error),
        () => {
          this.searchPatients(this.patientSearchObj, true);
        }
      );
  }
  //--------------------action buttons  handling
  onRowClick(actionCode: number, item: any) {
    //2293 edit  patient  data
    this.actionRowData = item;

    if (actionCode == 201) {
      this.selectedHistory(item);
    }
    if (actionCode == 202) {
      this.selectedPatient(item);
    }
    //7384  ايقاف او تكرارا الجلسات 
    if (actionCode == 7384) { //added by basma 
      this.duplicatSessionOrStop(item.code);
    }

    if (actionCode == 203) {
      this.patStopDeal(item);
    }
    if (actionCode == 32) {
      this._userSessionService.setSessionKey('patientForEdit', item);
      this.emitAddPatient.emit(32);
    }
    if (actionCode == 2121) {
      this.showFamily(item);
    }
    if (actionCode == 7350) {
      this.showOldSystemHistory(item);
    }
    if (actionCode == 6412) {
      this.selectedPatient(item);
    }
    if (actionCode == 6706) {
      this.openMedicalPatData(item);
    }
    else if (actionCode == 2132) {
      // Service history
      this.servicesHistory(item);
    }
    else if (actionCode == 6963) {
      this.futureReservationPrint(item);
    }
    else if (actionCode == 2416) {
      this.NicuVaccineSchedule(item);
    }
    else if (actionCode == 6500) { // open documents upload
      console.log('docserv => ', item);
      this.dynamicComponent = 3
      this.content2.openModal("FilesUploadComponent", "FilesUpload", item);
    }
  }

  servicesHistory(item) {
    this.dynamicComponent = ServiceHistoryComponent;
    this.content.openModal("ServiceHistoryComponent", "Reservations", item);

  }
  futureReservationPrint(selectedService: any) {
    this._userSessionService.setSessionKey("FutureReservationPrint", selectedService)
    this.dynamicComponent = FutureReservationPrintComponent;
    this.content.openModal("FutureReservationPrintComponent", "Reservations", selectedService);
  }
  openMedicalPatData(item: any) {
    this.dynamicComponent = MedicalDataPopupComponent;

    let masterParms = {
      componentType: 500,
      patientData: item,
      selectedTabs: [
        { tapCode: 'Allergy', selected: true },
        { tapCode: 'Diagnois', selected: true },
        { tapCode: 'Complains', selected: true },
        { tapCode: 'Finding', selected: true },
        { tapCode: 'OTHER_DATA', selected: true }
      ],
      dynamicDataLoad: true
    }

    this.content.openModal("MedicalDataPopupComponent", "masterParms", masterParms, 'xl');
  }

  showFamily(patient) {
    this.dynamicComponent = FamilyDetailComponent;

    this._userSessionService.setSessionKey('patient', patient);
    this.content.openModal("FamilyDetailComponent", "PatientListComponent", patient);
  }
  showOldSystemHistory(patient) {
    this.dynamicComponent = RegpatHistoryOnOldSystemComponent;

    this._userSessionService.setSessionKey('PatientListComponent', patient);
    this.content.openModal("RegpatHistoryOnOldSystemComponent", "PatientListComponent", patient);
  }

  NicuVaccineSchedule(patient) {
    this.dynamicComponent = NicuVaccineScheduleComponent;
    patient.flagPatient = 1;
    this._userSessionService.setSessionKey('patient', patient);
    this.content.openModal("NicuVaccineScheduleComponent", "PatientListComponent", patient);

  }
  ShowPatientService(actionCode: number, item: any) {
    //2293 edit  patient  data
    if (actionCode == 201) {
      this._userSessionService.setSessionKey("MediacalDataForPatient", item);
    }
  }
  //-----------after popups event
  onpopupClose(event) {
    if (event && event.name == 'PatStopDealComponent')
      this._userSessionService.setSessionKey('patientParms', null);
  }
  onRowSelect(event) {
    let patientData = event.data
    if (event.data) {
      if (!patientData.mobile || !patientData.identityValue || !patientData.nationalityId) {
        if (this.translate.currentLang == 'ar')
          var x = (!patientData.mobile ? 'رقم الهاتف   ' : '') + (!patientData.identityValue ? 'رقم الهويه ,  ' : '') + (!patientData.nationalityId ? 'رقم الجنسيه  , ' : '')
        else
          var x = (!patientData.mobile ? 'MOBILENUMBER  , ' : '') + (!patientData.identityValue ? 'identityValue ,  ' : '') + (!patientData.nationalityId ? 'nationalityId  , ' : '')

        this._toastService.activateMsg('GeneralError', x)
      }
    }
  }
  copyTextToClipboard(text: string) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          // إظهار رسالة النجاح باستخدام toastr
          this.toastr.success('Text copied to clipboard: ' + text);
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
          this.toastr.error('Failed to copy text: ' + err);
        });
    } else {
      // Fallback for browsers that do not support the Clipboard API
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';  // Prevent scrolling to the bottom of the page
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        document.execCommand('copy');
        this.toastr.success('Text copied to clipboard: ' + text);
      } catch (err) {
        console.error('Failed to copy text: ', err);
        this.toastr.error('Failed to copy text: ' + err);
      }

      document.body.removeChild(textarea);
    }
  }
}





